module.exports = __webpack_public_path__ + "assets/img/baby-bird.4c775a50.png";